import apiClient from '../axios'

export async function fetchSetting(group) {
  return apiClient
    .get('/setting/' + group)
    .then(response => {
      return response
    })
    .catch(err => err && err);
}

export async function update(group, data) {
  return apiClient
    .post('/setting/' + group, data)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}
